import React from 'react';
import HealixSession from '../HealixSession/HealixSession';
import { ScreeningTravellerTitle } from '../ScreeningTravellerTitle/ScreeningTravellerTitle';

const ActiveScreening = ({
  show,
  isScreeningActive,
  traveller,
  travellerIndex,
  onFinishScreening,
}) => {
  if (!show) {
    return null;
  }
  return (
    <div className="screening-session">
      <ScreeningTravellerTitle traveller={traveller} travellerIndex={travellerIndex} />
      <HealixSession
        travellerIndex={travellerIndex}
        onFinishScreening={onFinishScreening}
        isScreeningActive={isScreeningActive}
      />
    </div>
  );
};

export default ActiveScreening;
